import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/pagination";
import styles from "./CustomSwiper.module.scss";

interface CustomSwiperProps<T> {
  items: T[];
  modules?: any[]; // Swiper modules like Navigation, Thumbs, etc.
  swiperOptions?: Record<string, any>;
  onSlideClick?: (index: number, item: T) => void;
  onSwiperInit?: (swiper: SwiperType) => void;
  onSlideChange?: (swiper: SwiperType) => void;
  className?: string;
  renderSlide: (item: T, index: number) => React.ReactNode;
}

function CustomSwiper<T>({
  items,
  modules = [],
  swiperOptions = {},
  onSlideClick,
  onSwiperInit,
  onSlideChange,
  className = "",
  renderSlide,
}: CustomSwiperProps<T>) {
  return (
    <Swiper
      modules={modules}
      onSwiper={onSwiperInit}
      onSlideChange={onSlideChange}
      className={`${styles.defaultSwiper} ${className}`}
      {...swiperOptions}
    >
      {items?.map((item, index) => (
        <SwiperSlide
          key={index}
          onClick={() => onSlideClick?.(index, item)}
        >
          {renderSlide(item, index)}
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default CustomSwiper;
